var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyorderPendingApproval({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Myorder_Pending_Approval"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Myorder_Pending_Approval",
    "data-name": "Myorder_Pending Approval",
    clipPath: "url(#clip-Myorder_Pending_Approval)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clock",
    transform: "translate(-79.676 -80.376)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19434",
    "data-name": "Path 19434",
    d: "M79.8,87.374a6.877,6.877,0,1,1,6.8,6.879A6.891,6.891,0,0,1,79.8,87.374ZM86.651,93a5.625,5.625,0,1,0-5.6-5.666A5.636,5.636,0,0,0,86.651,93Z",
    fill: "#faac26",
    stroke: "#faac26",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19435",
    "data-name": "Path 19435",
    d: "M239.676,146.665c0-.533,0-1.066,0-1.6a.552.552,0,0,1,.528-.5.62.62,0,0,1,.685.372.91.91,0,0,1,.027.23c0,.9,0,1.806,0,2.708a.281.281,0,0,0,.113.237c.516.428,1.029.865,1.546,1.3a.477.477,0,0,1,.2.513.663.663,0,0,1-1.025.273c-.137-.1-.266-.217-.4-.329-.481-.4-.959-.809-1.44-1.208a.58.58,0,0,1-.239-.484c0-.5,0-1.007,0-1.514Z",
    transform: "translate(-153.62 -60.466)",
    fill: "#faac26"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyorderPendingApproval);
export default __webpack_public_path__ + "static/media/Myorder_Pending_Approval.a61ed9a6580e5e9c7d1cf964f0e538ca.svg";
export { ForwardRef as ReactComponent };